import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import NotificationTable from "components/menu/dashboard/merchandiser/notification-table";

import {
    fetchMerchandiserDashboardNotifications,
} from "api/menu/dashboard/actions";

class MerchandiserNotifications extends React.Component {
    constructor(props) {
        super(props);

        this.makeRequest = this.makeRequest.bind(this);

        this.makeRequest();
    }

    makeRequest = () => {
        this.props.fetchMerchandiserDashboardNotifications();
    };

    render () {
        const {
            comingDueIn48Hours,
            savedServices,
            unconfirmedServices,
            confirmedWithoutDateServices
        } = this.props.merchandiserNotifications;

        return (
            <div className="row">
                <div className="col">
                    <NotificationTable title="Unconfirmed Coming due in 48 hours" notification={comingDueIn48Hours} />
                </div>
                <div className="col">
                    <NotificationTable title="Unconfirmed" notification={unconfirmedServices} />
                </div>
                <div className="col">
                    <NotificationTable title="Confirmed without date" notification={confirmedWithoutDateServices} />
                </div>
                <div className="col">
                    <NotificationTable title="Saved but not Submitted" notification={savedServices} />
                </div>
            </div>
        );
    }
}

MerchandiserNotifications.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    merchandiserNotifications: state.dashboard.merchandiserNotifications,
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserDashboardNotifications: bindActionCreators(
        fetchMerchandiserDashboardNotifications,
        dispatch
    ),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MerchandiserNotifications);
